import { IPagingData, LeadBulkUpdateDto, LeadPermissions, PermissionScope } from '@sr/dto';
import { extractNestJsErrorMessage } from '../../shared/api/rtk-query';
import { leadsListApi } from './leads-list.api';
import { useUserAuth } from 'features/auth';
import { leadApi } from 'features/lead/api';

export const useLeads = (paging: IPagingData, params: URLSearchParams) => {
  const { user } = useUserAuth();
  const requestParams = buildLeadRequestParams(params, user?.permissions ?? []);
  const { data, isLoading, isFetching, error, refetch } = leadsListApi.useGetLeadsListQuery(
    { paging, filter: requestParams.toString() },
    { refetchOnMountOrArgChange: true }
  );
  return {
    collection: { items: data?.items ?? [], totalItemsCount: data?.totalItemsCount ?? 0, meta: data?.meta ?? [] },
    requestParams,
    isLoading,
    isFetching,
    error: extractNestJsErrorMessage(error),
    refetch
  };
};

export const buildLeadRequestParams = (params: URLSearchParams, permissions: PermissionScope[]) => {
  const requestParams = new URLSearchParams(params);
  if (permissions.includes(LeadPermissions.ACCESS_STATUS_NEW)) requestParams.set('showNew', 'true');
  if (permissions.includes(LeadPermissions.ACCESS_STATUS_UNKNOWN)) requestParams.set('showUnknown', 'true');
  if (permissions.includes(LeadPermissions.ADMIN)) requestParams.set('showAll', 'true');
  return requestParams;
};

export const useBulkUpdateLeads = () => {
  const [update] = leadsListApi.useBulkUpdateLeadsMutation();
  return async (formData: LeadBulkUpdateDto) => {
    return update({ ...formData }).unwrap();
  };
};

export const useLeadInvoices = (leadId: number) => {
  const { data, isLoading, error } = leadApi.useGetLeadInvoicesQuery(leadId);
  return { collection: data?.items ?? [], isLoading, error: extractNestJsErrorMessage(error) };
};
